export default "__VITE_ASSET__Ry0th17G__"